/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://fws94o37ba.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "GridFin",
            "endpoint": "https://6vc90m8ww4.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "scenario",
            "endpoint": "https://1ciujcmc1b.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xi5rr2t64zcyzgya5j57tmntsi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:a7ea4a95-75bf-46d3-a660-200208f122eb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_RgEbMEyIs",
    "aws_user_pools_web_client_id": "53qvog4hgskc9foshenkm3fo2b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "gridfinui-dev-qa",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d7nbfmu08wsa.cloudfront.net"
};


export default awsmobile;
